/**
 * @file SeoMovedNotice.tsx
 * @description Панель «Весь сайт → SEO» конструктора после переезда
 * (phase19.16, партия Р3в, v0.19.64; SB145, §2а плана): SEO-настройки сайта
 * больше не часть вида сайта — действуют сразу и живут в разделе «Сайт →
 * SEO». Вместо полей — одна строка и ссылка; закладки и старые ссылки на
 * панель не ломаются. SEO-поля конкретной страницы остаются в её настройках.
 */

import { Search } from "lucide-react";
import { Link } from "react-router";

import { Button } from "../ui/button";

export function SeoMovedNotice({ shopSlug }: { shopSlug: string }) {
  return (
    <div className="flex flex-col items-start gap-3 rounded-xl bg-surface-low p-4" data-testid="seo-moved-notice">
      <p className="type-body text-on-surface">
        SEO-настройки сайта теперь в разделе «Сайт → SEO»: заголовки и описание по умолчанию, картинка для ссылок, индексация,
        коды подтверждения, переадресации и проверка сайта. Сохранённое там действует сразу, без публикации.
      </p>
      <p className="type-caption text-on-surface-variant">Заголовок и описание отдельной страницы — в её настройках, группа «Для поиска».</p>
      <Button asChild variant="outline" className="max-sm:w-full">
        <Link to={`/shop/${shopSlug}/site/seo`}>
          <Search aria-hidden />
          Открыть «Сайт → SEO» →
        </Link>
      </Button>
    </div>
  );
}
